//#region ../base/fetch/util.ts
function parseQueryParams(usp, params) {
	for (const [key, value] of Object.entries(params)) if (Array.isArray(value)) if (key.endsWith("[]")) {
		for (const v of value) if (typeof value !== "undefined") usp.append(key, String(v));
	} else usp.set(key, value.join(","));
	else if (typeof value !== "undefined") usp.set(key, String(value));
}
function parseHeaders(headers, { authToken, contentType, transformHeaders }) {
	let _headers = { ...headers };
	const setContentTypeHeader = _headers["Content-Type"] !== null;
	if (setContentTypeHeader) switch (contentType) {
		case "json":
			_headers["Content-Type"] = "application/json";
			break;
		case "urlencoded":
			_headers["Content-Type"] = "application/x-www-form-urlencoded";
			break;
		case "none": delete _headers["Content-Type"];
	}
	if (authToken && !_headers.Authorization) _headers.Authorization = `${authToken}`;
	if (transformHeaders) _headers = transformHeaders(_headers);
	return Object.entries(_headers).reduce((acc, [key, value]) => {
		if (typeof value !== "undefined" && value !== null) acc[key] = String(value);
		return acc;
	}, {});
}
function isEmptyResponse(res) {
	if ([202, 204].includes(res.status)) return true;
	const contentLength = "headers" in res ? res.headers.get("content-length") : "getResponseHeader" in res ? res.getResponseHeader("content-length") : void 0;
	if (typeof contentLength === "string" && contentLength === "0" || typeof contentLength === "number" && contentLength === 0) return true;
	if (typeof window !== "undefined" && res instanceof XMLHttpRequest && !res.responseText) return true;
	return false;
}

//#endregion
export { isEmptyResponse, parseHeaders, parseQueryParams };
//# sourceMappingURL=util.js.map